import { Component, effect, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, SeasonStore } from 'store';
import { GetMatchModelExt } from '../core/entities';
import { MatchesService } from '../core/matches.service';

import { TranslateModule } from '@ngx-translate/core';
import { MatchBoxComponent } from '../shared/match-box/match-box.component';

@Component({
    templateUrl: './hall-of-shame.component.html',
    styleUrls: ['./hall-of-shame.component.scss'],
    imports: [MatchBoxComponent, TranslateModule],
})
export class HallOfShameComponent {
    private readonly matchesService = inject(MatchesService);
    private readonly store = inject<Store<AppState>>(Store);
    private readonly seasonStore = inject(SeasonStore);

    public matches: Array<GetMatchModelExt> = [];

    constructor() {
        effect(() => {
            const seasonId = this.seasonStore.seasonId();
            this.matchesService.load(10000, 0, seasonId, 'shame').subscribe((x) => (this.matches = x));
        });
    }
}
